export function withEnvLabel(title: string, label: string | undefined): string {
	const trimmed = label?.trim();
	if (!trimmed) return title;
	const prefix = `[${trimmed}] `;
	return title.startsWith(prefix) ? title : `${prefix}${title}`;
}
